import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getMarketplaceItems, GetMarketplaceItemsParams} from '../api';
import {QUERY__MARKETPLACE_ITEMS} from '../queryKeys';
import {MarketplaceItem} from '../types';

export const useGetMarketplaceItems = <
  SelectedData = GetListOutput<MarketplaceItem>,
>(
  params?: GetMarketplaceItemsParams,
  options?: QueryOptionsForList<MarketplaceItem, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__MARKETPLACE_ITEMS, params],
    queryFn: () => getMarketplaceItems(params),
    ...options,
  });
};
